import { AppUserContext } from "../providers";
import { UserGroups } from "../interfaces";
import { URLS } from "../utils";

type UserType = "coach" | "player";

const legacyRedirectMappings: Record<UserType, Record<string, string>> = {
  coach: {
    "/video-scripts": URLS.coach.videoScripts,
    "/video-script": URLS.coach.newVideoScript,
    "/video-script/:id": URLS.coach.videoScript,
    "/scripts/:id": URLS.coach.videoScript,
    "/videocatalyst": URLS.coach.videoProjects,
    "/videoproject/new": URLS.coach.newVideoProject,
    "/videoproject/detail/:id": URLS.coach.videoProject,
    "/api_management": URLS.coach.apiKeys,
    "/sign-up-profile": URLS.coach.companyInfo,
    "/settings/app-settings": URLS.coach.platformSettings,
    "/settings/digest": URLS.coach.digestEmails,
    "/player_cards": URLS.coach.playerCards,
    "/prompt/:promptId": URLS.coach.prompt,
    "/new-prompt": URLS.coach.newPrompt,
    "/coach-players": URLS.coach.players,
    "/coach-players/:playerId": URLS.coach.editPlayer,
    "/coach-players/new": URLS.coach.newPlayer,
    "/assistants": URLS.coach.assistants,
    "/assistants/:userId": URLS.coach.editAssistant,
    "/assistants/new": URLS.coach.newAssistant,
    "/video-page/new": URLS.coach.videoPages + "?new=true",
  },
  player: {
    "/scripts/:id": URLS.player.videoScript,
    "/player/player_cards": URLS.player.playerCards,
    "/player/library/video-script": URLS.player.newVideoScript,
    "/player/video-script/:id": URLS.player.videoScript,
    "/player/library/video-catalyst": URLS.player.videoProjects,
    "/player/videoproject/new": URLS.player.newVideoProject,
    "/videoproject/detail/:id": URLS.player.videoProject,
    "/player/library/video-catalyst/:id": URLS.player.videoProject,
    "/video-page/new": URLS.player.videoPages + "?new=true",
  },
};

export type LegacyRedirectRule = {
  path: string;
  getTo: (userContext: AppUserContext | undefined, params: Record<string, string>) => string;
};

export const getLegacyRedirectRules = (user: AppUserContext | undefined): LegacyRedirectRule[] => {
  if (!user) return [];
  var userType: UserType;
  if (user.account.scGroups && user.account.scGroups.some(g => g === UserGroups.COACH)) {
    userType = "coach";
  } else if (user.account.scGroups && user.account.scGroups.some(g => g === UserGroups.PLAYER)) {
    userType = "player";
  } else {
    return [];
  }

  return Object.entries(legacyRedirectMappings[userType]).map(([path, redirect]) => {
    return {
      path,
      getTo: (user, params) => {
        if (!user) return URLS.login;
        const effectiveRedirect = Object.entries(params).reduce((acc, [key, value]) => {
          return acc.replace(`:${key}`, value);
        }, redirect);
        return effectiveRedirect;
      },
    };
  });
};
